// 年表數據庫。
export const state = {
  reportYear: [
    {
      company_name: "",
      stock_symbol: 0,
      year_balance_sheets: [
        {
          accounts_and_bills_payable: "",
          accounts_and_bills_receivable: "",
          bank_loan_non_current: "",
          cash_and_cash_equivalents: "",
          commercial_paper_payable_acceptance_bill: "",
          corporate_bond: "",
          current_assets: "",
          current_liabilities: "",
          current_tax_liabilities: "",
          financial_liabilities_non_current: "",
          inventories: "",
          loan_to_other_S_T: "",
          long_term_investments: "",
          long_term_liabilities_due_within_one_year: "",
          non_current_assets: "",
          non_current_liabilities: "",
          other_current_assets: "",
          other_current_liabilities: "",
          other_equity: "",
          other_financial_liabilities_current: "",
          other_long_term_debt_payable_non_current: "",
          other_non_current_assets: "",
          other_payables: "",
          other_receivables: "",
          prepaid_expenses_and_repayments: "",
          property_plant_and_equipment: "",
          retained_earnings: "",
          share_capital: "",
          short_term_debt: "",
          short_term_financial_liability_current: "",
          short_term_investment_financial_assets_current: "",
          total_assets: "",
          total_capital_investment_IC: "",
          total_capital_reserve: "",
          total_equity: "",
          total_goodwill_and_intangible_assets: "",
          total_intangible_assets: "",
          total_liabilities: "",
          total_liabilities_and_stockholders_equity: "",
          total_other_L_T_liab: "",
          treasury_stock: "",
          year: ""
        }
      ],
      year_income_statements: [
        {
          EBIDTA: "",
          EPS: "",
          consolidated_net_income: "",
          cost_of_goods_sold: "",
          earnings_before_interest_and_tax: "",
          gains_and_losses_from_continuing_operations: "",
          income_before_tax: "",
          income_tax_expense: "",
          net_operating_revenue: "",
          operating_expenses: "",
          operating_income: "",
          other_comprehensive_income_OCI: "",
          other_gains_and_losses: "",
          realized_gross_profit: "",
          total_comprehensive_income: "",
          net_income_to_stockholders_company: "",
          comprehensive_income_to_stockholders_company: "",
          total_non_operating_revenue_and_expense: "",
          year: ""
        }
      ],
      year_cash_flow_statements: [
        {
          amortization_CFO: "",
          cash_dividends_paids_CFF: "",
          cash_flow_during_this_period: "",
          cash_flow_from_fundraising: "",
          cash_flow_from_investment_activities: "",
          cash_flows_from_operations: "",
          decrease_increase_in_accounts_receivable_CFO: "",
          decrease_increase_in_inventories_CFO: "",
          depreciation_CFO: "",
          disposals_of_property_plant_equipment_include_prepaid_CFI: "",
          increase_decrease_in_account_payable_CTO: "",
          profit_before_tax_CFO: "",
          purchases_of_property_plant_equipment_include_prepaid_CFI: "",
          year: ""
        }
      ]
    }
  ],
  errorMessage: ""
};
